<template>
    <div class="view_cont">
        <!-- tab -->
        <div class="view_desc">

            <div class="sub_tit">Contents Link Detail</div>

            <!-- Grid "btn-->
            <div v-if="gridData.length > 0">
                <toast-grid
                    gridId="gridCmsDetail"
                    :key="gridKey"
                    :data="gridData"
                    :columns="gridColumns"
                    :options="gridOptions"
                    :pageOptions="gridPageOptions"
                    :theme="gridTheme"
                    :isTotalCount="false"
                />
            </div>

            <div class="sub_tit">Contents Detail</div>

            <table class="data_table_ty2 mb-20" v-if="bizctt !== null">
                <colgroup>
                    <col width="15%" />
                    <col width="*" />
                    <col width="15%" />
                    <col width="*" />
                </colgroup>
                <tbody>
                    <tr>
                        <th class="text_left">Title</th>
                        <td colspan="3">
                            {{bizctt.CTTDESC}}
                        </td>
                    </tr>
                    <tr>
                        <th class="text_left">Product Type</th>
                        <td>
                            {{prodType}}
                        </td>
                        <th class="text_left">Proudct Subtype</th>
                        <td>
                            {{prodSubType}}
                        </td>
                    </tr>
                    <tr>
                        <th class="text_left">.COM Product Type</th>
                        <td>
                            {{bizcttlink[0].COMNMPRODTYPE}}
                        </td>
                        <th class="text_left">.COM Product Subtype</th>
                        <td>
                            {{bizcttlink[0].COMNMPRODSUBTYPE}}
                        </td>
                    </tr>
                    <tr>
                        <th class="text_left">Write Lang</th>
                        <td>
                            {{bizctt.WRITELANG}}
                        </td>
                        <th class="text_left">GBM</th>
                        <td>
                            {{bizctt.NMGBM}}
                        </td>
                    </tr>
                    <tr>
                        <th class="text_left">Create Date</th>
                        <td>
                            {{bizctt.DTCREATE}}
                        </td>
                        <th class="text_left">Create User</th>
                        <td>
                            {{bizctt.SIDCREATENM}}
                        </td>
                    </tr>
                    <tr>
                        <th class="text_left">Update Date</th>
                        <td>
                            {{bizctt.DTUPDATE}}
                        </td>
                        <th class="text_left">Update User</th>
                        <td>
                            {{bizctt.SIDUPDATENM}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <!-- //200420수정 E -->

            <div class="sub_tit">{{$t('SUBTITLE.GLOBAL.ATTACHED.FILES')}}</div>

            <toast-grid
                gridId="gridCmsDetailDownload"
                :key="gridKey"
                :data="gridDataDownload"
                :columns="gridColumnsDownload"
                :options="gridOptions"
                :pageOptions="gridPageOptions"
                :theme="gridTheme"
                :isTotalCount="false"
                v-bind:click="onGridCellClick"
            />
            
            <!-- Attachment -->
            <div style="margin-top: 60px;"
                v-if="loadInnorix">
                <innorix-download
                    uploadId="cmsDetail"
                    serviceType="cms"
                    :attachList="fileList"
                    :encToken="encToken"
                />

                <dl class="attachment_link" v-if="fileList.length > 0">
                    <dt><a href="javascript:" class="txt_link" @click="toggleLink($event)">Having trouble downloading?</a></dt>
                    <dd>
                        <ul>
                            <li v-for="file in fileList" :key="file.downloadUrl">
                                <a href="javascript:" @click="getDownloadUrl(file)" class="txt_link">
                                    <span class="ico_attach"></span> {{ file.filename }}
                                </a>
                            </li>
                        </ul>
                    </dd>
                </dl>

                
            </div>
        </div>

        <div class="btn_wrap topLine">
            <a href="javascript:" class="btn_white size_full"
                title @click="$emit('back-to-list')"
            >
                {{ $t('BUTTON.GLOBAL.LIST') }}
            </a>
            <!-- <div class="btn_right pc_only">
                <a href="javascript:" class="btn_white" title="">Expire</a>
                <a href="javascript:" class="btn_white" title="">Modify</a>
            </div>-->
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';

// import $ from 'jquery';
import qs from 'query-string';

// import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import { SDLUtil, DateUtil } from '@/utils';

import ToastGrid from '~c/ToastGrid';
// import Pagination from '@/components/common/control/pagination/Pagination';

// import { CellHtmlRenderer, HeaderHtmlRenderer } from '~c/GridCustomRenderer';

import InnorixDownload from '~c/InnorixDownload';

export default {
    components: {
        'toast-grid': ToastGrid,
        'innorix-download': InnorixDownload,
    },
    props: {
        cttid: {
            type: String,
            required: true,
        },
        prodType: {
            type: String,
            required: true,
        },
        prodSubType: {
            type: String,
            required: true,
        },
    },
    data() {
        return {

            bizctt: null,
            bizcttlink: [],

            loadInnorix: false,
            fileList: [],

            encToken: '',

            gridColumnsDownload: [
                {
                    header: 'No',
                    name: 'rnum',
                    width: 80,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Language',
                    name: 'writelang',
                    width: 110,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Version',
                    name: 'version',
                    width: 100,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'File Description',
                    name: 'stdkey',
                    align: 'center',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Date',
                    name: 'dtcreate',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'File Name',
                    name: 'filename',
                    align: 'center',
                    className: 'ftColor cur_pointer',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'File Size',
                    name: 'filesize',
                    width: 120,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],

            gridColumns: [
                {
                    header: 'Type',
                    name: 'CTTTYPE',
                    width: 80,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Model Name',
                    name: 'NMMODEL',
                    width: 90,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Model Code',
                    name: 'CDMODEL',
                    width: 100,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Version',
                    name: 'BOMVERSION',
                    width: 80,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Relation',
                    name: 'RELATION',
                    width: 80,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Nation',
                    name: 'NMNATION',
                    width: 180,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Description',
                    name: 'SHORTDESC',
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: true,
                    sortable: false,
                },
                {
                    header: 'Code',
                    name: 'CDPRODUCT',
                    width: 80,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Create Date',
                    name: 'DTREGISTER',
                    width: 90,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'E-BOM Date',
                    name: 'DTBOMCONFIRM',
                    width: 90,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Prod. Date',
                    name: 'DTGDWRESULT',
                    width: 90,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'D/E',
                    name: 'DOMEXP',
                    width: 80,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'Linked Date',
                    name: 'DTCREATE',
                    width: 90,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'STATUS',
                    name: 'STATUS',
                    width: 80,
                    align: 'center',
                    className: 'cur_pointer',
                    resizable: false,
                    sortable: false,
                },
            ],

            gridKey: '',

            gridData: [],
            gridDataDownload: [],

            gridOptions: {
                scrollX: true,
                scrollY: false,
            },

            gridPageOptions: null,

            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                },
            },
        };
    },

    computed: {
        ...mapGetters({
            params: 'getParams',
        }),
    },
    created() {
        this.initLoad();
    },
    // mounted() {
    // },
    methods: {
        async initLoad() {
            this.loadInnorix = false;
            const params = {
                CTTID: this.cttid,
                nmProdType: this.prodType,
                nmProdSubType: this.prodSubType,

                menuId: this.params.menuId,
            };
            SDLUtil.showLoadingBar(true);
            const path = '/basis/common/cmsContents/cmsContentsDetail.skp';
            const data = await SDLUtil.getRequest(path, params);
            SDLUtil.showLoadingBar(false);

            if (typeof data.result === undefined || data.result !== true) {
                SDLUtil.alert({
                    title: 'Loading error',
                    msg: 'Error',
                });
                return;
            }

            this.encToken = data.encToken;

            this.setGridData(data.bizcttlink);
            this.setDownloadGridData(data.fileinfoExt);
            this.setInnorixDownloadFileList(data.fileinfoExt);
            this.setBizctt(data.bizctt[0]);
            this.gridKey += 1;
        },

        setBizctt(bizctt) {
            this.bizctt = bizctt;
        },

        setGridData(list) {
            // list = list.map(item => {
            //     item.rowKey += 1;
            //     return item;
            // });
            this.gridData = list;
            this.bizcttlink = list;
        },

        setInnorixDownloadFileList(list) {
            console.log('fileList', list)
            this.fileList = list;
            // .map(item => {
            //     item.downloadUrl = item.downloadurl;
            //     return item;
            // });
            this.loadInnorix = true;
        },

        setDownloadGridData(list) {
            this.gridDataDownload = list;
        },

        onGridCellClick(event, rowData) {
            // console.log(event);
            if (typeof event.rowKey === 'undefined') return;
            const row = rowData[event.rowKey];
            // console.log('event rowKey', event.rowKey);
            // console.log('event columnName', event.columnName);
            // console.log('event rowData', rowData);
            // console.log('event row', row);

            if (event.columnName.toUpperCase() === 'FILENAME'.toUpperCase()) {
                if (row.downloadurl.substr(0, 1) === '/') {
                    const downloadUrl = `${SDLUtil.API_URL}${row.downloadurl}&encToken=${this.encToken}`;
                    //const downloadUrl = `${SDLUtil.API_URL}${row.downloadurl}`;
                    window.open(downloadUrl);
                } else {
                    window.open(row.downloadurl);
                }
            }
        },

        toggleLink(e) {
            $('.attachment_link > dd').toggle();
        },

        getDownloadUrl(file) {
            // const params = {
            //     encToken: this.encToken,
            // };
            // const cmsApiBase  = `http://skp.samsungcsportal.com/basis/common/cmsContents/cmsDownload.skp`;
            // // const downloadUrl = `${cmsApiBase}/basis/anysvcmobile/findcontent/FindContentDownLoad.skp?${qs.stringify(params)}`;
            // // let url = `${file.downloadUrl}?${qs.}`
            // return window.location.href = downloadUrl;

            if (file.downloadurl.substr(0, 1) === '/') {
                const downloadUrl = `${SDLUtil.API_URL}${file.downloadurl}&encToken=${this.encToken}`;
                //const downloadUrl = `${SDLUtil.API_URL}${file.downloadurl}`;
                window.open(downloadUrl);
            } else {
                window.open(file.downloadurl);
            }
            // return window.open(`${SDLUtil.API_URL}${file.downloadUrl}&encToken=${this.encToken}`);
            // return window.open(file.innoUrl);
        },
        getDownloadUrltok(file,fencToken) {
        	//alert("fencToken:"+fencToken);
        	//alert("encToken:"+this.encToken);
            // const params = {
            //     encToken: this.encToken,
            // };
            // const cmsApiBase  = `http://skp.samsungcsportal.com/basis/common/cmsContents/cmsDownload.skp`;
            // // const downloadUrl = `${cmsApiBase}/basis/anysvcmobile/findcontent/FindContentDownLoad.skp?${qs.stringify(params)}`;
            // // let url = `${file.downloadUrl}?${qs.}`
            // return window.location.href = downloadUrl;

            if (file.downloadurl.substr(0, 1) === '/') {
                //const downloadUrl = `${SDLUtil.API_URL}${file.downloadurl}&encToken=${this.encToken}`;
                const downloadUrl = `${SDLUtil.API_URL}${file.downloadurl}&encToken=${fencToken}`;
                window.open(downloadUrl);
            } else {
                window.open(file.downloadurl);
            }
            // return window.open(`${SDLUtil.API_URL}${file.downloadUrl}&encToken=${this.encToken}`);
            // return window.open(file.innoUrl);
        },
    },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/cmsContents/CmsDetail.vue